
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBatteryHorizontalPluggedNoCharge100 as ObiBatteryHorizontalPluggedNoCharge100Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-battery-horizontal-plugged-no-charge-100.js';
 
 
 

 
 export const ObiBatteryHorizontalPluggedNoCharge100 = createComponent({
   react: React,
   tagName: 'obi-battery-horizontal-plugged-no-charge-100',
   elementClass: ObiBatteryHorizontalPluggedNoCharge100Element,
   events: {
     
   }
  });
 
 